module.exports = __webpack_public_path__ + "static/media/wu-bg-alternate-logo-gray2_bp.235c1f75.svg";